// src/admin/CityPreview.js
import React, { useState } from 'react';

export default function CityPreview({ cityName, notes, existingImages = [] }) {
  const [idx, setIdx] = useState(0);
  const total = existingImages.length;

  const nav = (dir) => {
    if (total <= 1) return;
    setIdx((p) => (dir === 'next' ? (p + 1) % total : (p - 1 + total) % total));
  };

  return (
    <div>
      <h4>{cityName}</h4>
      <p>{notes || 'No notes'}</p>

      {total > 0 ? (
        <div style={{ position: 'relative', height: 200 }}>
          <img
            src={existingImages[idx]}
            alt=""
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }}
          />
          {total > 1 && (
            <>
              <button
                style={{ position: 'absolute', top: '50%', left: 10 }}
                onClick={() => nav('prev')}
              >
                ←
              </button>
              <button
                style={{ position: 'absolute', top: '50%', right: 10 }}
                onClick={() => nav('next')}
              >
                →
              </button>
              <div
                style={{
                  position: 'absolute',
                  bottom: 8,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: 'rgba(0,0,0,0.6)',
                  color: '#fff',
                  padding: '2px 8px',
                  borderRadius: 10,
                  fontSize: 12,
                }}
              >
                {idx + 1} / {total}
              </div>
            </>
          )}
        </div>
      ) : (
        <p style={{ color: 'gray' }}>No images</p>
      )}
    </div>
  );
}